import api from '@/lib/api';

export interface TasksQuery {
  unitId?: string;
  propertyId?: string;
  taskType?: string;
  status?: string;
  priority?: string;
  page?: number;
  limit?: number;
}

export interface CreateTaskPayload {
  unitId: string;
  taskType: string;
  title: string;
  description?: string | undefined;
  assignedTo?: string | null;
  priority: string;
  dueAt?: string | null;
  bookingId?: string | null;
  serviceTypeId?: string | undefined;
}

export interface UpdateTaskPayload {
  unitId?: string;
  taskType?: string;
  title?: string;
  description?: string;
  assignedTo?: string | null;
  priority?: string;
  dueAt?: string | null;
  bookingId?: string | null;
}

export async function fetchTasks(query?: TasksQuery) {
  const { data } = await api.get('/tasks', { params: query });
  return data;
}

export async function createTask(payload: CreateTaskPayload) {
  const { data } = await api.post('/tasks', payload);
  return data;
}

export async function updateTask(id: string, payload: UpdateTaskPayload) {
  const { data } = await api.patch(`/tasks/${id}`, payload);
  return data;
}

export async function completeTask(id: string) {
  const { data } = await api.post(`/tasks/${id}/complete`);
  return data;
}

export async function fetchHousekeepingStatus(unitId: string) {
  const { data } = await api.get(`/units/${unitId}/housekeeping`);
  return data;
}

export async function updateUnitHousekeepingStatus(unitId: string, status: string) {
  const { data } = await api.patch(`/units/${unitId}/housekeeping`, { status });
  return data;
}

// ── Housekeeping Staff & Batch Assignment ────────────────────────────────────

export interface StaffMember {
  id: string;
  name: string;
  email: string;
  role: string;
}

export async function fetchHousekeepingStaff(propertyId?: string): Promise<StaffMember[]> {
  const { data } = await api.get<StaffMember[]>('/housekeeping/staff', {
    params: propertyId ? { propertyId } : undefined,
  });
  return data;
}

export async function batchAssignHousekeeping(
  payload: { taskIds: string[]; assigneeId: string },
): Promise<{ assigned: number; assigneeId: string }> {
  const { data } = await api.post('/housekeeping/assign', payload);
  return data;
}
